import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import RSelect from 'react-select';

//internal import
import PageHeader from "../../components/common/PageHeader";
import useClientSubmit from "../../hooks/useClientSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ClientList from "../../components/Clients/ClientList";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import ClientService from "../../services/ClientService";
import Uploader from "../../components/imageuploader/Uploader";
import { useLocation } from 'react-router-dom';
import DropDownService from "../../services/DropDownService";

function Clients() {

    const [clientId, setClientId] = useState("");
    const { data, loading } = useAsync(() => ClientService.getAllClient());

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteClient,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl,
        setImageUrl,
        projectsArr,
        setProjectsArr,
        viewData } = useClientSubmit(clientId);

    const location = useLocation();
    const { pathname } = location;

    const { data: permissionData } = useAsync(() => DropDownService.getModulePermissions({ path: pathname, userId: localStorage.id }));
    const { data: projectData } = useAsync(() => DropDownService.projectDropDown());

    var addPermission = typeof permissionData?.data?.add === 'undefined' ? 1 : permissionData?.data?.add;
    var viewPermission = typeof permissionData?.data?.view === 'undefined' ? 1 : permissionData?.data?.view;
    var editPermission = typeof permissionData?.data?.edit === 'undefined' ? 1 : permissionData?.data?.edit;
    var deletePermission = typeof permissionData?.data?.delete === 'undefined' ? 1 : permissionData?.data?.delete;
    var listPermission = typeof permissionData?.data?.list === 'undefined' ? 1 : permissionData?.data?.list;

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Client" addPermission={addPermission} renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100 me-2" onClick={() => { setIsModal(true); setClientId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Client</button>
                        </div>
                    }} />
                    <ClientList deletePermission={deletePermission} editPermission={editPermission} viewPermission={viewPermission} listPermission={listPermission} setIsModal={setIsModal} setClientId={setClientId} setIsDeleteModal={setIsDeleteModal} setIsViewModal={setIsViewModal} data={data} />
                </>
            }

            {/* client view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Client Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Client Image </b>
                                </div>
                                <div className="col-sm-6">
                                    {viewData?.profileImage ? (
                                        <img src={viewData?.profileImage} alt="client" style={{ height: "200px", width: "200px" }} className="h-64 w-64" crossOrigin="anonymous" />
                                    ) : (
                                        <img
                                            src="https://res.cloudinary.com/ahossain/image/upload/v1655097002/placeholder_kvepfp.png"
                                            alt="slider"
                                            crossOrigin="anonymous"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Client Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.clientName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Company Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.companyName}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Client User Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.username}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b>Email</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.emailId}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Phone </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.phone}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Contact Person </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.contactPerson || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Projects </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{(viewData.projects && viewData.projects.length !== 0) ? viewData.projects.map((pro, i) => pro?.label + (i + 1 === viewData.projects.length ? "" : ",")) : "-"}</div>
                                </div>
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.status || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Description </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.description || "-"}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Client add and edit modal */}
            <Modal size="lg" centered show={isModal} onHide={() => { setIsModal(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{clientId ? "Update " : "Add"} Client</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput877" className="form-label">Client Name</label>
                                <InputArea register={register} name="clientName" label={"Name"} type="text" className="form-control" id="exampleFormControlInput877" placeholder="Client Name" />
                                <Error errorName={errors?.clientName} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput977" className="form-label">Company Name</label>
                                <InputArea register={register} name="companyName" label={"Company Name"} type="text" className="form-control" id="exampleFormControlInput977" placeholder="Compnay Name" />
                                <Error errorName={errors?.companyName} />
                            </div>
                            <div className="deadline-form">
                                <div className="row g-3 mb-3">
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput177" className="form-label">User Name</label>
                                        <InputArea register={register} name="username" label={"User Name"} type="text" className="form-control" id="exampleFormControlInput177" placeholder="User Name" />
                                        <Error errorName={errors?.username} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput277" className="form-label">Password</label>
                                        <InputArea register={register} required={!clientId} name="password" label={"Password"} type="Password" className="form-control" id="exampleFormControlInput277" placeholder="Password" />
                                        <Error errorName={errors?.password} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput477" className="form-label">Email ID</label>
                                        <InputArea register={register} name="emailId" label={"Email"} type="email" className="form-control" id="exampleFormControlInput477" placeholder="Enter Email" />
                                        <Error errorName={errors?.emailId} />
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput777" className="form-label">Phone</label>
                                        <InputArea register={register} name="phone" label={"Phone"} type="text" className="form-control" id="exampleFormControlInput777" placeholder="Enter Phone" />
                                        <Error errorName={errors?.phone} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput877" className="form-label">Contact Person</label>
                                        <InputArea register={register} required={false} name="contactPerson" label={"Contact Person"} type="text" className="form-control" id="exampleFormControlInput877" placeholder="Contact Person" />
                                        <Error errorName={errors?.contactPerson} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput877" className="form-label">Projects</label>
                                        <RSelect
                                            value={projectsArr}
                                            defaultValue={projectsArr}
                                            onChange={(e) => setProjectsArr(e)}
                                            name="projects"
                                            options={projectData?.data || []}
                                            isMulti="true"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                                        />
                                        <Error errorName={errors?.projects} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="departmentId" className="form-label">Status</label>
                                        <select className="form-select"
                                            name="status"
                                            {...register(`status`, {
                                                required: `Status is required!`,
                                            })}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="Active">Active</option>
                                            <option value="InActive">InActive</option>
                                        </select>
                                        <Error errorName={errors?.status} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Image</label>
                                        <Uploader
                                            imageUrl={imageUrl}
                                            setImageUrl={setImageUrl}
                                            folder="slider"
                                            name="image"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlTextarea78" className="form-label">Description (optional)</label>
                                <textarea  {...register(`description`, { required: false })} className="form-control" id="exampleFormControlTextarea78" rows="3" placeholder="Add any extra details about the request"></textarea>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{clientId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* client delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Client</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Client ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteClient(clientId)}>Delete</button>
                </Modal.Footer>
            </Modal>

        </div >

    )
}


export default Clients;